import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import type React from 'react';
import { Character } from '../../Character';
import { Dialog } from '../../Dialog';

export const COURSE_LESSON_SCENARIO_STORY_NORMAL_FRAGMENT =
  graphql(/* GraphQL */ `
  fragment EmbaCourseLessonScenarioStoryNormal on ScenarioContentNormal {
    ...on ScenarioContentNormal {
      dialog
      name
      character
    }
  }
`);

type NormalProps = {
  currentStoryContent: FragmentType<
    typeof COURSE_LESSON_SCENARIO_STORY_NORMAL_FRAGMENT
  >;
  isEnableNext: boolean;
  animationComplete: () => void;
  typingSpeed: number;
  showBlinkingArrow: boolean;
  isModalVisible: boolean;
  setIsModalVisible: (value: boolean) => void;
  slideToNext: () => void;
  embaUserlastName: string;
};

export const Normal: React.FC<NormalProps> = ({
  currentStoryContent,
  isEnableNext,
  animationComplete,
  typingSpeed,
  showBlinkingArrow,
  slideToNext,
  embaUserlastName,
}) => {
  const currentStoryContentData = useFragment(
    COURSE_LESSON_SCENARIO_STORY_NORMAL_FRAGMENT,
    currentStoryContent,
  );

  return (
    <>
      <Character character={currentStoryContentData.character} />
      <Dialog
        dialog={currentStoryContentData.dialog}
        name={currentStoryContentData.name}
        embaUserlastName={embaUserlastName}
        isEnableNext={isEnableNext}
        slideToNext={slideToNext}
        animationComplete={animationComplete}
        typingSpeed={typingSpeed}
        showBlinkingArrow={showBlinkingArrow}
      />
    </>
  );
};
